<template>
    <div class="columns is-mobile is-centered has-background-primary p-2" v-if="props.titoloVisibile==true">
        <h1 class="title is-4 has-text-white">LEAD DI VENDITA</h1>
    </div>

        <div class="columns is-mobile is-centered">
        <div class="column is-6" v-if="props.campoRicercaVisibile==true">
            <div class="field has-addons">
                <div class="control is-expanded">
                    <input class="input is-primary" type="text" v-model="testoRicerca" placeholder="Cerca..." @keyup.enter="bCerca(['codice', 'oggetto', 'stato', 'fase'])">
                </div>
                <div class="control">
                    <button class="button is-primary" @click="bCerca(['JSON'])">
                        <p><i class="fas fa-eye"></i></p>
                    </button>
                </div>
            </div>
        </div>
        <div class="column is-1 has-text-centered" v-if="props.bottoneAggiungiVisibile==true && !schermoLargo">
            <button class="button is-primary is-outlined" @click="bSelezionaLead(-1, null)">
                <span class="icon"><i class="fas fa-plus"></i></span>
            </button>
        </div>
        <div class="column is-1 has-text-right" v-if="props.campoRicercaVisibile==true && schermoLargo">
            <button class="button is-primary is-outlined" title="Mostra grafici" @click="bMostraGrafici()">
                <span class="icon"><i class="fas fa-chart-line"></i></span>
            </button>
        </div>
        <div class="column is-1 has-text-left" v-if="props.campoRicercaVisibile==true">
            <button class="button is-primary is-outlined" title="Mostra mappa" @click="bMostraMappa()">
                <span class="icon"><i class="fas fa-map-marked-alt"></i></span>
            </button>
        </div>
    </div>

    <div class="blocco-scroll" v-if="!schermoLargo">
    <div class="box" v-for="(ld) in elencoLeads" :key="leggiInfoDB(ld).id">
            <button class="button is-small is-primary is-outlined" @click="bSelezionaLead(leggiInfoDB(ld).id, leggiInfoDB(ld).idCliente)">
                <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
            </button>
            &nbsp; &nbsp; <ComponenteIcona :nome="ld.stato" />
            &nbsp; &nbsp; <span class="icon has-text-danger" title="Vitoadvisor" v-if="ld.primoContattoFonte == 'Vitoadvisor'"><i class="fas fa-solid fa-v"></i></span>
            &nbsp; &nbsp; {{ld.fase}}
            <div v-if="props.cliente==null"> <a @click="emit('elementoSelezionato', {tipo: 'cliente', idCliente: leggiInfoDB(ld).idCliente})">{{leggiInfoDB(ld).stringaCliente}}</a> </div>
            <div v-if="ld.oggetto"> {{ld.oggetto}} </div>
            <div v-if="ld.ultimoContattoData"> Ultimo contatto: {{dataDaTimestamp(ld.ultimoContattoData, 'testo')}} </div>
        </div>
        <div>
            &nbsp;  &nbsp; &nbsp; &nbsp; {{stringaNumeroRecord}}
        </div>
        <div>&nbsp;</div>
    </div>

    <div class="blocco-scroll" v-if="schermoLargo">
        <table class="table is-striped mx-auto">
            <thead>
                <tr>
                    <th class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaLead(-1, null)" v-if="props.bottoneAggiungiVisibile==true">
                            <span class="icon"><i class="fas fa-plus"></i></span>
                        </button>
                    </th>
                    <th v-if="mostraInfoSviluppo"></th>
                    <th class="has-text-centered" v-if="mostraInfoSviluppo">Id</th>
                    <th class="has-text-centered">Stato</th>
                    <th class="has-text-centered"></th>
                    <th class="has-text-centered">Fase</th>
                    <th v-if="props.cliente==null">Cliente</th>
                    <th>Oggetto</th>
                    <th>Ultimo contatto</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(ld, index) in elencoLeads" :key="leggiInfoDB(ld).id">
                    <td class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaLead(leggiInfoDB(ld).id, leggiInfoDB(ld).idCliente)">
                            <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
                        </button>
                    </td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{index + 1}}</td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{leggiInfoDB(ld).id}}</td>
                    <td class="has-text-centered">
                        <ComponenteIcona :nome="ld.stato" />
                    </td>
                    <td class="has-text-centered">
                        <span class="icon has-text-danger" title="Vitoadvisor" v-if="ld.primoContattoFonte == 'Vitoadvisor'"><i class="fas fa-solid fa-v"></i></span>
                    </td>
                    <td class="has-text-centered">{{ld.fase}}</td>
                    <td v-if="props.cliente==null"><a @click="emit('elementoSelezionato', {tipo: 'cliente', idCliente: leggiInfoDB(ld).idCliente})">{{leggiInfoDB(ld).stringaCliente}}</a></td>
                    <td>{{ld.oggetto}}</td>
                    <td class="has-text-centered">{{dataDaTimestamp(ld.ultimoContattoData, 'testo')}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="has-text-centered" colspan="2">{{stringaNumeroRecord}}</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <GraficoVendite
        :datiGrafico="datiGraficoVendite"
        @selezionato="bComandoModale"
        v-if="mostraGraficoVendite"
    />
    <MappaPin 
        v-if="vistaMappa"
        titoloMappa="Mappa Leads"
        :datiMappa="datiMappaLeads"
        @selezionato="bComandoModale"
        @elementoSelezionato="(el) => emit('elementoSelezionato', el)"
    />
</template>

<script setup>
    import GraficoVendite from "./GraficoVendite.vue";
    import MappaPin from './MappaPin.vue';
    import ComponenteIcona from "./ComponenteIcona.vue";
    import { defineProps, defineEmits, computed, ref } from "vue";
    import { dataDaTimestamp, mostraInfoSviluppo, schermoLargo, getValorePerOrdinamento } from "@/code/utilita";
    import { dbClienti, dbContatti, leggiInfoDB, leggiInfoDBRaw } from "@/code/gestioneDB";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        cliente: {
            type: Number,
            default: null },
        testoDaCercare: {
            type: String,
            default: null },
        campiDaCercare: {
            type: Array,
            default:  () => {return ['codice', 'oggetto', 'stato', 'fase']}
        },
        bottoneAggiungiVisibile: {
            type: Boolean,
            default: false },
        campoRicercaVisibile: {
            type: Boolean,
            default: true },
        elencoTassativo: {
            type: Object,
            default: () => {return null}
        },
        titoloVisibile: {
            type: Boolean,
            default: true }
    });
    const emit = defineEmits(['elementoSelezionato', 'statoInterfacciaCambiato']);


    // VARIABILI DEL COMPONENTE
    const datiGraficoVendite = ref([]);
    const datiMappaLeads = ref([]);
    const testoRicerca = ref(props.testoDaCercare);
    const stringaNumeroRecord = ref("");
    const mostraGraficoVendite = ref(false);
    const vistaMappa = ref(false);

    // SETUP DEL COMPONENTE
    const elencoLeads = computed(()=>{
        let tempElencoLeads = [];
        if (props.cliente==null && props.elencoTassativo==null) {
            // Elenco completo di tutti i Lead di tutti i Clienti
            for(const cl in dbClienti.value){
                // FIX: Scudo condizionale
                if (dbClienti.value[cl] && dbClienti.value[cl].leads) {
                    for(const ld in dbClienti.value[cl].leads){
                        tempElencoLeads.push(dbClienti.value[cl].leads[ld]);
                    }
                }
            }
        } else if (props.elencoTassativo!=null) {
            // E' stato passato un elenco di Lead da visualizzare
            for(const ld in props.elencoTassativo){
                const idCl = props.elencoTassativo[ld].cliente;
                // FIX: Scudo condizionale
                if (dbClienti.value[idCl] && dbClienti.value[idCl].leads) {
                    tempElencoLeads.push(dbClienti.value[idCl].leads[ld]);
                }
            }
        } else {
            // FIX DEFINITIVA: Verifichiamo che il cliente (es. -1) esista in RAM prima di leggere .leads
            if (dbClienti.value[props.cliente] && dbClienti.value[props.cliente].leads) {
                for(const ld in dbClienti.value[props.cliente].leads){
                    tempElencoLeads.push(dbClienti.value[props.cliente].leads[ld]);
                }
            }
        }
        ordinaElencoLeads(tempElencoLeads);
        filtraElencoElementi(tempElencoLeads, props.testoDaCercare, props.campiDaCercare, 40);
        return tempElencoLeads;
    });

    // FUNZIONI DEL COMPONENTE

    function bCerca(campi) {
        emit('statoInterfacciaCambiato', {testoRicercaLeads: testoRicerca.value, campiRicercaLeads: campi});
    }

    function bSelezionaLead(idLd, idCl) {
        let tempIdCl;
        if (props.cliente!=null) {
            tempIdCl = props.cliente;
        } else {
            tempIdCl = idCl;
        }
        emit('elementoSelezionato', {
            tipo: 'lead',
            idCliente: tempIdCl,
            idLead: idLd
        });
    }

     // Dizionario dei pesi (tutto in minuscolo per via della normalizzazione)
    const PESO_STATO = {
        'urgente': 5,
        'in verifica': 4,
        'in attesa': 3,
        'archiviato': 2,
        'non processato': 1
    };

    function ordinaElencoLeads(elenco) {
        elenco.sort((a, b) => {
            const statoA = getValorePerOrdinamento(a, 'stato', false);
            const statoB = getValorePerOrdinamento(b, 'stato', false);

            const valA = PESO_STATO[statoA] !== undefined ? PESO_STATO[statoA] : 5;
            const valB = PESO_STATO[statoB] !== undefined ? PESO_STATO[statoB] : 5;

            if (valA !== valB) {
                return valB - valA; 
            } 
            
            const dataA = getValorePerOrdinamento(a, 'ultimoContattoData', false) || 0;
            const dataB = getValorePerOrdinamento(b, 'ultimoContattoData', false) || 0;

            return dataB - dataA;
        });

        return elenco;
    }

    function filtraElencoElementi(elencoEl, testo, campi, numMax) {
        const tempStringaNumeroRecord = elencoEl.length;
        let elencoTesti = [];
        if (testo) elencoTesti = testo.split('+');
        for (let j=0; j < elencoTesti.length; j++) {
            if ( (elencoTesti[j]) && (elencoTesti[j]!="") ) {
                for (let i=0; i < elencoEl.length; i++) {
                    const regexCerca = new RegExp(elencoTesti[j], 'i');
                    let temp = null;
                    let pos = -1;
                    if ( campi[0] == 'JSON' ) {
                        temp = JSON.stringify(elencoEl[i]);
                        pos = temp.search(regexCerca);
                        if (pos==-1) {
                            if (elencoEl[i].contatti){
                                for(const ct of Object.keys(elencoEl[i].contatti)){
                                    if (dbContatti.value[ct]) {
                                        temp = JSON.stringify(dbContatti.value[ct]);
                                        pos = temp.search(regexCerca);
                                        if (pos!=-1) {
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        if (pos==-1) {
                            temp = leggiInfoDBRaw(elencoEl[i]).stringaCliente;
                            if (temp) { 
                                pos = temp.search(regexCerca);
                            }
                        }
                    } else {
                        for (const cc in campi) {
                            if (pos == -1) {
                                if ( Array.isArray(campi[cc]) ) {
                                    if(elencoEl[i][campi[cc][0]] && elencoEl[i][campi[cc][0]][campi[cc][1]]){
                                       temp = elencoEl[i][campi[cc][0]][campi[cc][1]];
                                    } else {
                                        temp = "";
                                    }
                                } else {
                                    temp = elencoEl[i][campi[cc]];
                                }
                                pos = String(temp).search(regexCerca);
                            }
                        }
                        if (pos==-1) {
                            temp = leggiInfoDBRaw(elencoEl[i]).stringaCliente;
                            if (temp) { 
                                pos = temp.search(regexCerca);
                            }
                        }
                    }

                    if (pos == -1) {
                        elencoEl.splice(i,1);
                        i--;
                    }
                }
            }
        }
        if (numMax) {
            if (elencoEl.length>(numMax+5)){
                elencoEl.splice(numMax,(elencoEl.length-numMax));
            }
        }
        stringaNumeroRecord.value = elencoEl.length + " di " + tempStringaNumeroRecord;
    }

    // function bMostraGrafici() {
    //     let tempDatiGraficoVendite = {};
    //     for (const cl in dbClienti.value) {
    //         for (const ld in dbClienti.value[cl].leads) {
    //             for (const pr in dbClienti.value[cl].leads[ld].preventivi) {
    //                 if (dbClienti.value[cl].leads[ld].preventivi[pr].attivo == true) {
    //                     let stringaData = dataDaTimestamp(dbClienti.value[cl].leads[ld].preventivi[pr].data, 'testoAA-MM');
    //                     if (tempDatiGraficoVendite[stringaData] == undefined) {
    //                         tempDatiGraficoVendite[stringaData] = 0;
    //                     }
    //                     tempDatiGraficoVendite[stringaData] += dbClienti.value[cl].leads[ld].preventivi[pr].importo?dbClienti.value[cl].leads[ld].preventivi[pr].importo:0;
    //                 }
    //             }
    //         }
    //     }
    //     datiGraficoVendite.value = [];
    //     for (const mese in tempDatiGraficoVendite) {
    //         datiGraficoVendite.value.push([mese, tempDatiGraficoVendite[mese]]);
    //     }
    //     datiGraficoVendite.value.sort( (a, b) => {
    //         if (a[0] < b[0]) {
    //             return -1;
    //         }
    //         if (a[0] > b[0]) {
    //             return 1;
    //         }
    //         return 0;
    //     });
    //     datiGraficoVendite.value.unshift(['Mese', 'Importo']);

    //     mostraGraficoVendite.value = true;
    // }

function bMostraGrafici() {
        let tempDati = {};
        let setTags = new Set();

        for (const cl in dbClienti.value) {
            // Scudo condizionale di sicurezza
            if (!dbClienti.value[cl] || !dbClienti.value[cl].leads) continue;

            for (const ld in dbClienti.value[cl].leads) {
                const lead = dbClienti.value[cl].leads[ld];
                
                // 1. Processa i preventivi attivi (Importo Economico)
                if (lead.preventivi) {
                    for (const pr in lead.preventivi) {
                        const prev = lead.preventivi[pr];
                        if (prev.attivo == true && prev.data) {
                            let stringaData = dataDaTimestamp(prev.data, 'testoAA-MM');
                            if (!tempDati[stringaData]) {
                                tempDati[stringaData] = { importo: 0, totaleLeads: 0, tags: {} };
                            }
                            tempDati[stringaData].importo += prev.importo ? prev.importo : 0;
                        }
                    }
                }

                // 2. Processa i Lead (Flussi di Contatto e Tags)
                if (lead.primoContattoData) {
                    let stringaData = dataDaTimestamp(lead.primoContattoData, 'testoAA-MM');
                    if (!tempDati[stringaData]) {
                        tempDati[stringaData] = { importo: 0, totaleLeads: 0, tags: {} };
                    }
                    tempDati[stringaData].totaleLeads += 1;

                    // Conteggio Tags specifici
                    if (lead.tags && Array.isArray(lead.tags)) {
                        lead.tags.forEach(tag => {
                            setTags.add(tag);
                            if (!tempDati[stringaData].tags[tag]) {
                                tempDati[stringaData].tags[tag] = 0;
                            }
                            tempDati[stringaData].tags[tag] += 1;
                        });
                    }
                }
            }
        }

        // Estrai e ordina i tag unici trovati nel periodo
        const arrayTags = Array.from(setTags).sort();
        
        datiGraficoVendite.value = [];
        
        // Costruisci la matrice dei dati per Google Charts
        for (const mese in tempDati) {
            let row = [mese, tempDati[mese].importo, tempDati[mese].totaleLeads];
            arrayTags.forEach(tag => {
                row.push(tempDati[mese].tags[tag] || 0);
            });
            datiGraficoVendite.value.push(row);
        }

        // Ordina cronologicamente
        datiGraficoVendite.value.sort((a, b) => {
            if (a[0] < b[0]) return -1;
            if (a[0] > b[0]) return 1;
            return 0;
        });

        // Inserisci l'intestazione dinamica delle colonne
        datiGraficoVendite.value.unshift(['Mese', 'Importo Preventivi', 'Totale Leads', ...arrayTags]);

        mostraGraficoVendite.value = true;
    }

    function bComandoModale(comando) {
        if (comando == 'chiudi') {
            mostraGraficoVendite.value = false;
            vistaMappa.value = false;
        }
    }

    function bMostraMappa() {
        datiMappaLeads.value = [];
        
        let tempElencoLeads = [];
        for(const cl in dbClienti.value){
            for(const ld in dbClienti.value[cl].leads){
                tempElencoLeads.push(dbClienti.value[cl].leads[ld]);
            }
        }
        filtraElencoElementi(tempElencoLeads, props.testoDaCercare, props.campiDaCercare);

        tempElencoLeads.forEach(lead => {
            if (lead.luogo && typeof lead.luogo === 'string' && lead.luogo.includes(',')) {
                const parts = lead.luogo.split(',');
                if (parts.length >= 2) {
                    const lat = parseFloat(parts[0].trim());
                    const lng = parseFloat(parts[1].trim());

                    if (!isNaN(lat) && !isNaN(lng)) {
                        let titolo = lead.oggetto || 'Lead senza oggetto';
                        const info = leggiInfoDBRaw(lead);
                        if (info && info.stringaCliente) {
                            titolo = info.stringaCliente + " - " + titolo;
                        }

                        datiMappaLeads.value.push({
                            lat: lat,
                            lng: lng,
                            titolo: titolo,
                            colore: 'rosso',
                            payload: {
                                tipo: 'lead',
                                idLead: info.id,
                                idCliente: info.idCliente
                            }
                        });
                    }
                }
            }
        });

        vistaMappa.value = true;
    }

</script>